import checksJson from "./public-link-checks.json" with { type: "json" };
const checks = checksJson as Record<string, { state: string; status: number | null }>;
export const ACCESS_REVIEW_DATE = "2026-09-09";
export type LinkRestriction = { kind: "private" | "unavailable"; label: string; message: string };

/** An unblocked link is not a guarantee of open access. */
export function linkRestriction(href?: string): LinkRestriction | null {
  if (!href) return null;
  let url: URL;
  try { url = new URL(href, "https://miguelguerrero.eu/agencytransfer/"); }
  catch { return { kind: "unavailable", label: "link unavailable", message: "This address could not be resolved." }; }
  if (!["http:", "https:", "mailto:", "tel:", "blob:"].includes(url.protocol)) return { kind: "unavailable", label: "link unavailable", message: "This is not a supported link." };
  let path: string;
  try { path = decodeURIComponent(url.pathname).toLowerCase(); } catch { path = url.pathname.toLowerCase(); }
  const host = url.hostname.toLowerCase();
  const repositoryPath = host === "api.github.com" ? path.replace(/^\/repos/, "") : path;
  if (["github.com", "www.github.com", "raw.githubusercontent.com", "api.github.com", "codeload.github.com"].includes(host)
    && /^\/apolmig\/agencytransfer(?:\.git)?(?:\/|$)/.test(repositoryPath)) {
    return { kind: "private", label: "not public", message: "This project record is in a private repository. Its citation is retained, but the file is not publicly available." };
  }
  url.hash = "";
  if (checks[url.href]?.state === "not_found") return { kind: "unavailable", label: "link unavailable", message: "This address returned not found in the public-access check on 9 September 2026. The citation is retained." };
  return null;
}
